import Vue from 'vue'
import Router from 'vue-router'

import Index from './views/index/Index.vue'

import NotFound from './views/not_found/NotFound.vue'
import Auth from './views/auth/Auth.vue'
import AuthCallback from './views/auth_callback/AuthCallback.vue'
import RequestExchange from './views/request_exchange/RequestExchange.vue'
import RequestExchangeConfirm from './views/request_exchange_confirm/RequestExchangeConfirm.vue'
import RequestExchangeComplete from './views/request_exchange_complete/RequestExchangeComplete.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Index
    },
    {
      path: '/auth',
      name: 'auth',
      component: Auth
    },
    {
      path: '/auth_callback',
      name: 'auth-callback',
      component: AuthCallback
    },
    {
      path: '/request_exchange',
      name: 'request-exchange',
      component: RequestExchange
    },
    {
      path: '/request_exchange_confirm',
      name: 'request-exchange-confirm',
      component: RequestExchangeConfirm
    },
    {
      path: '/request_exchange_complete',
      name: 'request-exchange-complete',
      component: RequestExchangeComplete
    },
    {
      path: '*',
      name: 'not-found',
      component: NotFound
    }
  ]
})
